// Health & Sports segment - spas, massages, gyms, nail salons, sports clubs
export const HEALTH_IMAGES = {
  hero: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1600&q=80",
  wine: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1600&q=80",
  coffee: "https://images.unsplash.com/photo-1600334129128-685c5582fd35?auto=format&fit=crop&w=900&q=80",
  bar: "https://images.unsplash.com/photo-1552693673-1bf958298935?auto=format&fit=crop&w=1200&q=80",
};

const en = {
  hero: {
    eyebrow: "For Health & Sports",
    h1a: "Book. Sweat.",
    h1b: "Glow.",
    p: "Spas, massages, gyms, yoga studios, nail salons, tennis and Muay Thai clubs - list every service, every class and every day pass in one place, commission-free.",
    zero: "Zero commissions,",
    ever: "ever",
    cta: "Claim your business",
    tagline: "Live in minutes \u00b7 No commissions ever \u00b7 Cancel anytime",
  },
  chips: [
    { icon: "Flower2", label: "Spa & massage" },
    { icon: "Sparkles", label: "Facials" },
    { icon: "Sun", label: "Yoga & pilates" },
    { icon: "Dumbbell", label: "Gym day passes" },
    { icon: "Zap", label: "Personal training" },
    { icon: "Waves", label: "Sauna & wellness" },
    { icon: "Hand", label: "Manicure & pedicure" },
    { icon: "Trophy", label: "Muay Thai & tennis" },
  ],
  benefits: {
    eyebrow: "Why andAbout",
    h2a: "Every treatment,",
    h2b: "booked in advance.",
    p: "Walk-ins are unpredictable. andAbout gives your studio, spa or club a bookable schedule that guests, tourists and locals can browse and pay for from their phone - in their own language.",
    items: [
      { icon: "CalendarCheck2", title: "Direct bookings & class schedules", body: "Guests book a massage, a Muay Thai class or a gym day pass straight from your profile with live availability - no phone calls, no missed slots." },
      { icon: "Languages", title: "Multilingual service menus", body: "Upload once in English. We translate every treatment, class and package into 12+ languages so every guest understands what they're booking." },
      { icon: "QrCode", title: "QR credit card payments", body: "Guests pay at reception with a card, from their phone. Faster check-in for you, no wallet hunt for them." },
      { icon: "Heart", title: "Turn one-timers into members", body: "Follower lists let you announce new classes, day-pass promos or the new therapist the moment they launch - straight to your regulars." },
    ],
  },
  audience: {
    eyebrow: "Who books you",
    h2a: "The whole island,",
    h2b: "not just walk-ins.",
    p: "Your best clients are the ones who booked yesterday. andAbout puts your schedule in front of everyone nearby the moment they need a massage, a class or a workout.",
    items: [
      { tag: "01", heading: "Tourists tonight", body: "Travelers searching for a spa, class or gym pass right now find you in their own language." },
      { tag: "02", heading: "Hotel guests", body: "Concierges send guests to your treatment room directly from andAbout - no phone tag, no bad handoffs." },
      { tag: "03", heading: "Locals & members", body: "Residents follow your studio, get class alerts and day-pass promos, and become the crowd that fills your quiet mornings." },
    ],
    stats: [
      { k: "48k+", v: "monthly island searches" },
      { k: "12", v: "languages, auto-translated" },
      { k: "0%", v: "commission on your bookings" },
      { k: "20 min", v: "average time to go live" },
    ],
  },
  marketing: {
    eyebrow: "Included with your subscription",
    h2a: "We put you in",
    h2b: "our marketing.",
    p: "andAbout runs campaigns across the island every day, on social and in search. As a subscriber, your new class, day-pass promo or opening special becomes part of the story we tell tourists and locals. You bring the space - we bring the bodies.",
  },
  steps: {
    eyebrow: "Getting started",
    h2a: "Live in minutes,",
    h2b: "not months.",
    items: [
      { n: "1", title: "Claim your business", body: "Your profile may already exist, pre-populated and ready. Claim it in minutes." },
      { n: "2", title: "Add services & schedule", body: "List treatments, classes, day passes and packages with prices and live availability." },
      { n: "3", title: "Fill every slot", body: "Guests, tourists and locals book directly. You keep every baht - andAbout never takes a commission." },
    ],
  },
  faq: {
    eyebrow: "Questions & answers",
    h2a: "Everything you were",
    h2b: "about to ask.",
    items: [
      { q: "Do you really take zero commission?", a: "Yes. andAbout charges a flat monthly subscription and never takes a cut of your bookings or memberships. Card payments are processed by Stripe, and the full processing cost is passed through from Stripe with no markup from andAbout: by default, 3% is added at checkout for the customer and 2% is charged to the business." },
      { q: "Can I sell class packs and memberships?", a: "Yes. Sell single sessions, class packs, day passes, weekly and monthly memberships, and time-limited promos. Guests see live availability and pay from their phone." },
      { q: "What kinds of services can I list?", a: "Massage, spa treatments, facials, yoga and pilates classes, gym day passes, personal training, sauna and wellness, manicure and pedicure, Muay Thai, tennis, football, dive fitness - anything you offer today plus things you've been meaning to package." },
      { q: "How do guests actually book?", a: "Through the andAbout app or website. Bookings, class RSVP and paid packs are built in - no phone calls, no missed sessions." },
      { q: "When do I get paid?", a: "Money lands in your bank account up to 7 days after the guest attended. Guests can cancel up to 48 hours before their session for a full refund, so payout is settled once that window has passed." },
      { q: "Can we cancel anytime?", a: "Yes. Both Plus and Partner are month-to-month. Annual plans include two months free but you can still cancel renewal any time." },
    ],
  },
};
export const HEALTH_TRANSLATIONS = { en, th: en, ru: en };
